"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xpIntegrationConfigSchema = void 0;
const zod_1 = require("zod");
exports.xpIntegrationConfigSchema = zod_1.z.object({
    xp_office_id: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    delta_date: zod_1.z.number().default(0),
});
